interface Params {
  label: string
}

export const Label: React.FC<Params> = ({ label }) => {
  return <div className="font-bold text-gray-500">{label}</div>
}
